import { render } from "./ApplyInvoice.vue?vue&type=template&id=54ab7be4"
import script from "./ApplyInvoice.vue?vue&type=script&lang=ts"
export * from "./ApplyInvoice.vue?vue&type=script&lang=ts"
script.render = render

export default script